import FetchError from "./errors";
import { ITokenRequest } from "../models";
import { customFetchWithRetry } from "./shared";

export const registerDeviceToken = async (tokenRequest: ITokenRequest): Promise<Boolean | null> => {
  try {
    const response = await customFetchWithRetry(`/user/${tokenRequest.username}/device`, {
      method: "PUT",
      body: JSON.stringify(tokenRequest)
    })
    if (response.ok) {
      return true;
    }

    throw new FetchError(`Error fetching. ${await response.text()}`, response.status);
  } catch (e) {
    throw new FetchError(e, 500);
  }
};